import { render } from "./LoadingFrame.vue?vue&type=template&id=3f295886"
import script from "./LoadingFrame.vue?vue&type=script&lang=js"
export * from "./LoadingFrame.vue?vue&type=script&lang=js"

import "./LoadingFrame.vue?vue&type=style&index=0&id=3f295886&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__